import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    question01:[
      { id:0, img:require('@/assets/img/img_interior01.jpg') },
      { id:1, img:require('@/assets/img/img_interior02.jpg') },
      { id:2, img:require('@/assets/img/img_interior03.jpg') },
      { id:3, img:require('@/assets/img/img_interior04.jpg') },
      { id:4, img:require('@/assets/img/img_interior05.jpg') },
      { id:5, img:require('@/assets/img/img_interior06.jpg') },
      { id:6, img:require('@/assets/img/img_interior07.jpg') },
      { id:7, img:require('@/assets/img/img_interior08.jpg') },
    ],
    question02:[
      { id:0, img:require('@/assets/img/img_exterior01.jpg') },
      { id:1, img:require('@/assets/img/img_exterior02.jpg') },
      { id:2, img:require('@/assets/img/img_exterior03.jpg') },
      { id:3, img:require('@/assets/img/img_exterior04.jpg') },
      { id:4, img:require('@/assets/img/img_exterior05.jpg') },
      { id:5, img:require('@/assets/img/img_exterior06.jpg') },
      { id:6, img:require('@/assets/img/img_exterior07.jpg') },
      { id:7, img:require('@/assets/img/img_exterior08.jpg') },
    ],
    question03:[
      { id:0, val:1, img:require('@/assets/img/img_q3_01.png') },
      { id:1, val:2, img:require('@/assets/img/img_q3_02.png') },
      { id:2, val:3, img:require('@/assets/img/img_q3_03.png') },
      { id:3, val:4, img:require('@/assets/img/img_q3_04.png') },
    ],
    question04:[
      { id:0, type:'A', text:'性能・スペック' },
      { id:1, type:'B', text:'デザイン' },
      { id:2, type:'C', text:'間取り・設計' },
      { id:3, type:'D', text:'アフターサービス' },
      { id:4, type:'E', text:'コスト・価格' },
    ],
    question05:[
      { id:0, val:1, text:'リビング学習' },
      { id:1, val:2, text:'ワークスペース' },
      { id:2, val:3, text:'リアルサイズ' },
      { id:3, val:4, text:'こだわりの木材' },
      { id:4, val:5, text:'吹抜け' },
      { id:5, val:6, text:'玄関手洗い' },
      { id:6, val:7, text:'セカンドリビング' },
      { id:7, val:8, text:'屋上活用' },
      { id:8, val:9, text:'ウッドデッキ・テラス' },
      { id:9, val:10, text:'ガレージ' },
      { id:10, val:11, text:'大型パントリー' },
      { id:11, val:12, text:'アイデア収納' },
      { id:12, val:13, text:'小屋裏収納' },
      { id:13, val:14, text:'家事導線' },
      { id:14, val:15, text:'土間空間' }, 
    ],
    housemaker:[
      {
        id:0,
        name:'アールプランナー',
        img:require('@/assets/img/img_exterior01.jpg'),
        title:'arr gallery',
        href:'https://35s.co.jp/chukyotvh/house/komaki16/',
        q3:{ 1:2, 2:1, 3:3, 4:4 },
        q4:{ 1:'B', 2:'A', 3:'D', 4:'C' ,5:'E'},
        q5:{
          1:[3,8,14],
          2:[1,2,6,11],
          3:[4,5,7,9,10,12,13,15]
        },
        haspoint:0
      },
      {
        id : 1,
        name:'セキスイハイム中部',
        img:require('@/assets/img/img_exterior02.jpg'),
        title:'スマートパワーステーションGR',
        href:'https://35s.co.jp/chukyotvh/house/komaki09/',
        q3:{ 1:2, 2:1, 3:3, 4:4 },
        q4:{ 1:'A', 2:'D', 3:'C', 4:'B' ,5:'E'},
        q5:{
          1:[2,6,14],
          2:[1,11,12,15],
          3:[3,4,5,7,8,9,10,13]
        },
        haspoint:0
      },
      {
        id : 2,
        name:'ヤマカ木材',
        img:require('@/assets/img/img_exterior03.jpg'),
        title:'Naturie',
        href:'https://35s.co.jp/chukyotvh/house/komaki04/',
        q3:{ 1:3, 2:1, 3:2, 4:4 },
        q4:{ 1:'A', 2:'E', 3:'C', 4:'D' ,5:'B'},
        q5:{
          1:[3,4,1],
          2:[9,15,14,12],
          3:[8,5,10,13,6,11,2,7]
        },
        haspoint:0
      },
      {
        id : 3,
        name:'三和木',
        img:require('@/assets/img/img_exterior04.jpg'),
        title:'三和木の家',
        href:'https://35s.co.jp/chukyotvh/house/komaki15/',
        q3:{ 1:2, 2:1, 3:4, 4:3 },
        q4:{ 1:'B', 2:'C', 3:'A', 4:'E' ,5:'D'},
        q5:{
          1:[1,4,15],
          2:[3,5,9,14],
          3:[2,6,7,8,10,11,12,13]
        },
        haspoint:0
      },
      {
        id : 4,
        name:'新和建設',
        img:require('@/assets/img/img_exterior05.jpg'),
        title:'季光風土',
        href:'https://35s.co.jp/chukyotvh/house/komaki11/',
        q3:{ 1:2, 2:1, 3:3, 4:4 },
        q4:{ 1:'A', 2:'C', 3:'D', 4:'B' ,5:'E'},
        q5:{
          1:[1,4,12],
          2:[2,9,10,14],
          3:[3,5,6,7,8,11,13,15]
        },
        haspoint:0
      },
      {
        id : 5,
        name:'積水ハウス',
        img:require('@/assets/img/img_exterior06.jpg'),
        title:'DYNE CONCRETE LIFE IS ROY+E',
        href:'https://35s.co.jp/chukyotvh/house/komaki13/',
        q3:{ 1:2, 2:1, 3:4, 4:3 },
        q4:{ 1:'B', 2:'E', 3:'C', 4:'D' ,5:'A'},
        q5:{
          1:[12,1,14],
          2:[7,11,4,2],
          3:[10,5,9,13,8,3,7,15]
        },
        haspoint:0
      },
      {
        id : 6,
        name:'善匠',
        img:require('@/assets/img/img_exterior07.jpg'),
        title:'ADORER',
        href:'https://35s.co.jp/chukyotvh/house/komaki14/',
        q3:{ 1:2, 2:1, 3:3, 4:4 },
        q4:{ 1:'B', 2:'C', 3:'D', 4:'A' ,5:'E'},
        q5:{
          1:[5,7,9],
          2:[1,2,12,14],
          3:[3,4,6,8,10,11,13,15]
        },
        haspoint:0
      },
      {
        id : 7,
        name:'福工房',
        img:require('@/assets/img/img_exterior08.jpg'),
        title:'土間のある家',
        href:'https://35s.co.jp/chukyotvh/house/komaki02/',
        q3:{ 1:1, 2:2, 3:3, 4:4 },
        q4:{ 1:'C', 2:'D', 3:'E', 4:'A' ,5:'B'},
        q5:{
          1:[4,5,14],
          2:[1,2,11,12],
          3:[3,6,7,8,9,10,13,15]
        },
        haspoint:0
      }
    ],
    answer:[
      // [{"id":4,"val":5},{"id":1,"val":5},{"id":0,"val":5}],
      // [{"id":0,"val":5},{"id":1,"val":5},{"id":4,"val":5}],
      // [{"id":0,"val":3},{"id":1,"val":3},{"id":2,"val":5},{"id":3,"val":2},{"id":4,"val":3},{"id":5,"val":2},{"id":6,"val":3},{"id":7,"val":3}],
      // [{"id":0,"val":12},{"id":1,"val":9},{"id":2,"val":5},{"id":3,"val":8},{"id":4,"val":8},{"id":5,"val":5},{"id":6,"val":8},{"id":7,"val":4}],
      // [{"id":0,"val":6},{"id":1,"val":4},{"id":2,"val":3},{"id":3,"val":4},{"id":4,"val":3},{"id":5,"val":4},{"id":6,"val":5},{"id":7,"val":6}]
    ],
  },
  getters:{
    question01: function(state){
      return state.question01
    },
    question02: function(state){
      return state.question02
    },
    question03: function(state){
      return state.question03
    },
    question04: function(state){
      return state.question04
    },
    question05: function(state){
      return state.question05
    },
    housemaker: function(state){
      return state.housemaker
    },
    answer: function(state){
      return state.answer
    }
  },
  mutations: {
    incrementPoint(state,obj){
      state.housemaker.forEach(function(el){
        Object.keys(obj).forEach(function(o){
          if(el.id === obj[o].id){
            el.haspoint = obj[o].val
          }
        })
      })
    },
    answerPoint(state,Ans){
      state.answer[Ans.name] = Ans.obj
    }
  }
})
